var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "momo-product-item"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": _vm.product.image
    }
  })]), _c('div', {
    staticClass: "right-content"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.product.title))]), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.product.secondTitle))]), _c('div', {
    staticClass: "d-flex justify-content-between align-items-center"
  }, [_c('div', {
    staticClass: "point"
  }, [_vm._v(_vm._s(_vm.product.point) + "點")]), _c('div', {
    staticClass: "cta-area w-50 d-flex justify-content-center flex-column"
  }, [_vm.showDate ? _c('div', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.product.date))]) : _vm._e(), _c('div', {
    staticClass: "cta"
  }, [_vm.product.status === 'available' ? _c('img', {
    attrs: {
      "src": require("./images/momo_cta_button_available.png")
    },
    on: {
      "click": function click($event) {
        return _vm.doRedeem(_vm.product);
      }
    }
  }) : _vm._e(), _vm.product.status === 'finish' ? _c('img', {
    attrs: {
      "src": require("./images/momo_cta_button_finish.png")
    }
  }) : _vm._e(), _vm.product.status === 'point_disable' ? _c('img', {
    attrs: {
      "src": require("./images/momo_cta_button_point_disable.png")
    }
  }) : _vm._e(), _vm.product.status === 'redeemed' ? _c('img', {
    attrs: {
      "src": require("./images/momo_cta_button_redeemed.png")
    }
  }) : _vm._e()])])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }